<div class="popover-arrow arrow"></div>
<span class="popover-title popover-header d-flex" *ngIf="title">{{ title }}</span>
<div class="popover-content popover-body">
  <ng-content></ng-content>
</div>
